import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const selectorWatchlistState = (state: RootState) => state.watchlist;

export const selectorWatchlist = createSelector(
  selectorWatchlistState,
  (watchlistState) => watchlistState
);
